import { memo } from 'react';

import GoogleDriveIcon from '@/assets/google-drive-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type GoogleDriveLogoProps = LogoProps;

const IGoogleDriveLogo = ({ className, ...rest }: GoogleDriveLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <GoogleDriveIcon className="size-5" />
    </Logo>
  );
};

export const GoogleDriveLogo = memo(IGoogleDriveLogo) as typeof IGoogleDriveLogo;
